


























import Vue from "vue";
import ReportTable from "@/components/organisms/ReportTable/index.vue";
import SearchInput from "@/components/organisms/SearchInput/index.vue";
import CreateButton from "@/components/molecules/Buttons/CreateButton.vue";
import ModalCreateNewTemplate from "@/components/organisms/modal/ModalCreateNewTemplate/index.vue";
import ModalUpdateTemplate from "@/components/organisms/modal/ModalUpdateTemplate/index.vue";
import { ModalProgrammatic } from "buefy/dist/components/modal";
import { Report, SearchCondition } from "@/types/entities.ts";

export default Vue.extend({
  components: {
    ReportTable,
    CreateButton,
    SearchInput,
  },
  data() {
    return {
      value: "すべて",
      data: [],
    };
  },
  props: {
    tableData: {
      type: Array,
    },
    getTemplates: {
      type: Function,
      require: true,
    },
    reportLabels: {
      type: Array,
    },
    getReportLabels: {
      type: Function,
      require: true,
    },
    condition: {
      type: Object,
    },
  },
  computed: {
    getCurrentInfo() {
      let rel: Report = {
        report_id: "",
        report_name: "",
        token: "",
      };
      const currentId  = this.$route.params.group_id;
      const groups = this.$store.state.report.reportGroups;
      groups.forEach((item: any) => {
        if (item.report_id === currentId) {
          rel = Object.assign({}, item);
        }
      });
      return rel;
    },
  },
  methods: {
    handleOnCreate() {
      this.$emit("createTemplate");
    },
    handleOnDelete(value: any) {
      this.$emit("deleteTemplates", value);
    },
    openNewTemplateModal() {
      ModalProgrammatic.open({
        parent: this,
        component: ModalCreateNewTemplate,
        hasModalCard: true,
        props: {
          reportId: this.getCurrentInfo.report_id,
        },
      });
    },
    handleOnUpdateRowItem(item: any) {
      ModalProgrammatic.open({
        parent: this,
        component: ModalUpdateTemplate,
        hasModalCard: true,
        props: {
          reportId: this.getCurrentInfo.report_id,
          currentInfo: Object.assign({}, item),
        },
      });
    },
    handleOnChangeFilterCondition(condition: SearchCondition) {
      this.$store.dispatch("report/changeSearchCondition", condition);
    },
  },
  mounted() {
    // this.getReportLabels();
    this.getTemplates();
  },
  watch: {
    $route(to, from) {
      this.handleOnChangeFilterCondition({group: "すべて", keyword: ""});
      this.getReportLabels();
      this.getTemplates();
    },
  },
});
